<template>
  <div>
    <div class="dashboard-content-wrapper">
      <div class="dashboard-block dashboard-donations">
        <div class="dashboard-donations__header">
          <h2 class="dashboard-block__title">{{ $t("dashboard.title_teams") }}</h2>
          <div class="btn-wrapper">
            <button :disabled="!hasAccessAdd" class="bttn bttn--sm bttn--orange" @click="addTeam">
              {{ $t("teams.add_new_team") }}
            </button>

            <button
              class="bttn bttn--orange ml-2"
              @click="publishSelectedBulk"
              :disabled="!onHoldBulkActionsConditions.publishEventPageTeams"
            >
              {{
                $t(
                  "dashboard.teams_bulk_actions_publish_event_page",
                  "Publish Selected ({count})",
                  { count: bulkEventPageTeams.length }
                )
              }}
            </button>

            <email-message ref="emailMessage" />
            <sms-message ref="smsMessage" />

            <div class="btn-group delete-all-teams">
              <b-dropdown
                :disabled="!hasAccessEdit"
                variant="-sm bttn--bordered-blue"
                right
                :text="$t('edit_campaign.teams_options')"
              >
                <b-dropdown-item @click="openModalImportTeams" v-if="hasAccessAdd">{{
                  $t("edit_campaign.import_teams")
                }}</b-dropdown-item>
                <b-dropdown-item @click="openModalExportTeams">{{
                  $t("edit_campaign.export_button_teams_title")
                }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>

        <div class="dashboard-donations__filters">
          <!-- search -->
          <div class="filter-block dashboard-donation__search" v-if="canSeeInputSearch">
            <label class="pb-2 form-unit__label">{{ $t("dashboard.filter_search") }}</label>
            <div class="search">
              <svg viewBox="0 0 17 17">
                <g fill="#107598" fill-rule="nonzero">
                  <path
                    d="M11.22 3.29c.2.2.38.41.55.64l-.12-.16c.33.44.61.93.83 1.44l-.08-.19a6.76 6.76 0 0 1 .42 1.48 6.92 6.92 0 0 1 .03 1.52 6.76 6.76 0 0 1-.45 1.69l.08-.2c-.22.52-.5 1-.83 1.45l.12-.16c-.34.45-.74.85-1.18 1.2l.16-.12c-.43.34-.91.62-1.42.84l.2-.08a6.41 6.41 0 0 1-1.45.43 6.52 6.52 0 0 1-1.5.03 6.41 6.41 0 0 1-1.65-.46l.19.08c-.5-.22-.98-.5-1.42-.84l.16.12a6.67 6.67 0 0 1-1.18-1.2l.12.16a6.78 6.78 0 0 1-.83-1.45l.08.2a6.76 6.76 0 0 1-.42-1.48 6.92 6.92 0 0 1-.03-1.52c.08-.58.23-1.15.45-1.69l-.08.2c.22-.52.5-1 .83-1.45l-.12.16c.34-.45.74-.86 1.18-1.2l-.16.12c.44-.34.91-.62 1.42-.84l-.2.08a6.41 6.41 0 0 1 1.45-.43 6.52 6.52 0 0 1 1.5-.03c.57.08 1.12.23 1.65.46L9.33 2a6.43 6.43 0 0 1 1.89 1.28c.3.3.83.32 1.11 0a.83.83 0 0 0 0-1.14A7.13 7.13 0 0 0 .92 3.77a7.46 7.46 0 0 0 .85 8.43 7.16 7.16 0 0 0 9.02 1.58 7.53 7.53 0 0 0 2.48-2.38 7.46 7.46 0 0 0-.94-9.25c-.29-.3-.82-.32-1.11 0a.83.83 0 0 0 0 1.14z"
                  />
                  <path
                    d="M11.28 12.42l1.47 1.47 2.34 2.34.54.54c.3.3.85.32 1.14 0a.82.82 0 0 0 0-1.14l-1.47-1.47-2.34-2.34-.54-.54c-.3-.3-.85-.32-1.14 0a.82.82 0 0 0 0 1.14z"
                  />
                </g>
              </svg>
              <input
                v-model="searchQ"
                class="search__input"
                type="text"
                :placeholder="$t('dashboard.select_filter_placeholder_input')"
                value
              />
            </div>
          </div>

          <!-- statuses -->
          <div class="filter-block dashboard-donation__type">
            <label class="pb-2 form-unit__label">{{ $t("dashboard.filter_statuses") }}</label>
            <div class="select">
              <svg viewBox="0 0 12 6">
                <path
                  fill="#A0A1AC"
                  fill-rule="nonzero"
                  d="M.28.28a.6.6 0 0 0 .02.86l5.25 4.6c.26.22.64.22.88 0l5.25-4.6c.26-.22.28-.6.02-.84a.65.65 0 0 0-.9-.02L6 4.48 1.18.26a.67.67 0 0 0-.9.02z"
                />
              </svg>
              <select class="select__select" v-model="sortBy">
                <option value>{{ $t("dashboard.teams_filter_sort_by") }}</option>
                <option value="goal">{{ $t("dashboard.teams_filter_goal") }}</option>
                <option value="-goal">{{ $t("dashboard.teams_filter_goal_desc") }}</option>
                <option value="raised">{{ $t("dashboard.teams_filter_raised") }}</option>
                <option value="-raised">{{ $t("dashboard.teams_filter_raised_desc") }}</option>
                <option value="percent">{{ $t("dashboard.teams_filter_percent") }}</option>
                <option value="-percent">{{ $t("dashboard.teams_filter_percent_desc") }}</option>
              </select>
            </div>
          </div>

          <div class="filter-block dashboard-donation__type">
            <label class="pb-2 form-unit__label">{{ $t("dashboard.filter_show_all") }}</label>
            <div class="select">
              <svg viewBox="0 0 12 6">
                <path
                  fill="#A0A1AC"
                  fill-rule="nonzero"
                  d="M.28.28a.6.6 0 0 0 .02.86l5.25 4.6c.26.22.64.22.88 0l5.25-4.6c.26-.22.28-.6.02-.84a.65.65 0 0 0-.9-.02L6 4.48 1.18.26a.67.67 0 0 0-.9.02z"
                />
              </svg>
              <select class="select__select" v-model="sortByShown">
                <option value>{{ $t("dashboard.teams_filter_all") }}</option>
                <option value="true">{{ $t("dashboard.teams_filter_hidden") }}</option>
                <option value="false">{{ $t("dashboard.teams_filter_shown") }}</option>
              </select>
            </div>
          </div>

          <div class="filter-block dashboard-donation__type">
            <label class="pb-2 form-unit__label">{{ $t("dashboard.parent_team") }}</label>
            <multiselect-search
              class="pb-2"
              v-model="parentTeamId"
              :open-prefetch="true"
              :search-url="getTeamSearchUrl"
              :search-options="teamSearchOptions"
              aria-describedby="parent-team-help"
            >
              <template #no-options>
                {{ $t("dashboard.team_search_no_options", "Please enter 1 or more characters") }}
              </template>
              <template #no-more-infinite>
                {{ $t("dashboard.team_search_no_more", "No more teams") }}
              </template>
            </multiselect-search>
            <b-form-checkbox
              v-model="including_grand_children"
              name="including grand children"
              :value="1"
              :unchecked-value="0"
              >{{ $t("dashboard.filters_including_grand_children") }}</b-form-checkbox
            >
          </div>
        </div>

        <div class="dashboard-donations__th">
          <div class="th-item th-item--5"></div>
          <div class="th-item th-item--5">ID</div>
          <div class="th-item clickable th-item--name" @click="setSort('name')">
            {{ $t("dashboard.team_name") }}
            <i :class="classSortBy('name')"></i>
            <tooltip :title="$t('dashboard.team_name_tooltip', 'Team name')" class="mx-1" />
          </div>
          <div class="th-item th-item--name">
            {{ $t("dashboard.team_leader") }}
            <i :class="classSortBy('team_leader')"></i>
            <tooltip
              :title="$t('dashboard.team_leader_tooltip', 'Team leader name')"
              class="mx-1"
            />
          </div>
          <div class="th-item clickable" @click="setSort('goal')">
            {{ `${$t("dashboard.team_goal")} (${selectedCampaignCurrency})` }}
            <i :class="classSortBy('goal')" />
            <tooltip :title="$t('dashboard.team_goal_tooltip', 'Team goal')" class="mx-1" />
          </div>
          <div class="th-item clickable" @click="setSort('raised')">
            {{ $t("dashboard.team_raised") }}
            <i :class="classSortBy('raised')"></i>
            <tooltip
              :title="$t('dashboard.team_raised_tooltip', 'Team total amount')"
              class="mx-1"
            />
          </div>
          <div class="th-item">
            {{ $t("dashboard.team_number_of_donors", "Number of donors") }}
            <tooltip
              :title="$t('dashboard.team_number_of_donors_tooltip', 'Number of donors')"
              class="mx-1"
            />
          </div>
          <div class="th-item clickable" @click="setSort('percent')">
            {{ $t("dashboard.team_percent") }}
            <i :class="classSortBy('percent')"></i>
            <tooltip :title="$t('dashboard.team_percent_tooltip', 'Team progress')" class="mx-1" />
          </div>
          <div class="th-item th-item--name">
            {{ $t("dashboard.team_page_show") }}
            <tooltip
              :title="$t('dashboard.team_page_show_tooltip', 'Team visibility')"
              class="mx-1"
            />
          </div>
          <div class="th-item">
            {{ $t("dashboard.diff_goal_raised", "Diff (goal-raised)") }}
            <tooltip
              :title="
                $t(
                  'dashboard.diff_goal_raised_tooltip',
                  'Difference between goal and raised amount'
                )
              "
              class="mx-1"
            />
          </div>
          <div class="th-item">
            {{ $t("dashboard.team_publish", "Publish/Unpublish") }}
          </div>
        </div>
      </div>

      <div v-if="!loading">
        <div>
          <dashboard-teams-unit
            v-for="team in teams"
            :key="team.id"
            :team="team"
            @edit-team="editTeam"
            @team-published="loadNewPageTeams"
          />

          <team-form
            ref="teamform"
            :dashboard="true"
            :currentpage="page"
            :searchvalue="searchQ"
            :shortlink="selectedCampaign.attributes.short_link"
            :ccy="selectedCampaign.attributes.currency"
          />

          <div v-if="teamsCount === 0" class="empty">
            <p>{{ $t("dashboard.teams_empty") }}</p>
          </div>
          <div v-if="teamsCount > perPage" class="pagination">
            <b-pagination
              v-model="page"
              :total-rows="teamsCount"
              :per-page="perPage"
              size="md"
            ></b-pagination>
          </div>
        </div>
      </div>

      <div v-if="loading">
        <div class="loadings">
          <LdsSpinner />
        </div>
      </div>
    </div>

    <import-teams
      ref="ImportTeamsModal"
      :campaignId="campaignId"
      @send-email="sendEmail"
      @send-sms="sendSMS"
    />
    <export-teams ref="ExportTeamsModal" />
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import debounce from "lodash/debounce";
import MultiselectSearch from "@/components/multiselect-search.vue";

import teamForm from "@/views/campaigns/campaign-edit-vue/subcomponents/team-form.vue";
import importTeams from "@/views/campaigns/campaign-edit-vue/subcomponents/campaign-import-teams.vue";
import exportTeams from "@/views/dashboard/subcomponents/export-teams-modal.vue";

import dashboardTeamsUnit from "./dashboardTeamsEventUnit.vue";
import smsMessage from "./messaging/smsMessage.vue";
import emailMessage from "./messaging/emailMessage.vue";
import LdsSpinner from "@/common-components/ui-elements/lds-spinner.vue";
import urls, { publicApiHost } from "@/constants/urls.js";
import Tooltip from "@/common-components/tooltip.vue";
import axios from "axios";

export default {
  components: {
    teamForm,
    dashboardTeamsUnit,
    MultiselectSearch,
    smsMessage,
    emailMessage,
    importTeams,
    exportTeams,
    Tooltip,
    LdsSpinner,
  },

  data() {
    return {
      apiUrl: publicApiHost,
      page: 1,
      perPage: 50,
      searchQ: "",
      sortBy: "",
      sortByShown: "",
      parentTeamId: null,
      parent_team_id: null,
      including_grand_children: false,
    };
  },

  directives: {
    debounce,
  },

  computed: {
    ...mapState({
      campaignId: (state) => state.dashboard.selectedCampaign,

      canSeeInputSearch: (state) => state.account.access.CanPerformDonationSearch,

      selectedCampaign(state) {
        return state.campaigns.campaigns.find((cmp) => cmp.id === this.campaignId);
      },

      selectedCampaignCurrency: (state) =>
        state.dashboard.campaignDashboard.data.attributes.currency_code,

      teams: (state) => state.teams.teams,

      loading: (state) => state.teams.loadingTeam,

      teamsCount: (state) => state.teams.teamsCount,

      hasAccessAdd: (state) => state.account.access.CanAddCampaignTeams,
      hasAccessEdit: (state) => state.account.access.CanEditCampaignTeams,

      bulkEventPageTeams: (state) => state.teams.bulkEventPageTeams,
    }),
    onHoldBulkActionsConditions() {
      return {
        publishEventPageTeams: this.bulkEventPageTeams.length > 0,
      };
    },
    orgId: function () {
      return localStorage.getItem("orgId");
    },

    getTeamSearchUrl() {
      const cID = this.campaignId;
      const orgID = this.orgId;

      if (Number(cID) === 0) {
        throw new Error("getTeamSearchUrl dashboard teams event parent picker campaign id is 0");
      }

      return urls.apiTeams.replace(":orgId", orgID).replace(":campaignId", cID);
    },

    teamSearchOptions() {
      return {
        placeholder: this.$t("dashboard.select_parent_team"),
        changeParams: ({ query, page, per_page: pp }) => ({
          q: query,
          page: page,
          limit: pp,
        }),
        customLabel: (e) => `[${e.id}] ${e.name}`,
        processResults: (data) =>
          data.map((el) => ({
            id: el.id,
            ...el.attributes,
          })),
      };
    },
  },

  watch: {
    campaignId() {
      this.page = 1;
      this.getTeams();
    },
    page() {
      this.getTeams();
    },
    sortBy() {
      this.page = 1;
      this.getTeams();
    },
    sortByShown() {
      this.page = 1;
      this.getTeams();
    },
    searchQ: debounce(function () {
      this.page = 1;
      this.getTeams();
    }, 500),
    parentTeamId: debounce(function () {
      if (this.parentTeamId) {
        this.parent_team_id = Number(this.parentTeamId.id);
      } else {
        this.parent_team_id = 0;
      }
      this.page = 1;
      this.getTeams();
    }, 500),
    including_grand_children() {
      this.getTeams();
    },
  },

  methods: {
    ...mapMutations({
      uncheckBulkEventPageTeams: "uncheck_bulkEventPageTeams",
    }),

    setSort(sortBy) {
      if (this.sortBy != sortBy && this.sortBy != `-${sortBy}`) {
        this.sortBy = sortBy;
      } else if (this.sortBy == sortBy) {
        this.sortBy = `-${sortBy}`;
      } else {
        this.sortBy = "";
      }
    },

    classSortBy(sortBy) {
      if (this.sortBy == sortBy) {
        return "fa fa-angle-up";
      } else if (this.sortBy == "-" + sortBy) {
        return "fa fa-angle-down";
      }
    },

    getTeams() {
      const {
        page,
        perPage,
        sortBy,
        sortByShown,
        searchQ,
        parent_team_id,
        including_grand_children,
      } = this;
      const params = {
        page,
        limit: perPage,
        q: searchQ ? searchQ : undefined,
        sort: sortBy ? sortBy : undefined,
        hidden: sortByShown,
        extend: ["stats"],
        parent_team_id,
        including_grand_children,
      };
      this.$store.dispatch("getTeamsByCampaignId", [this.campaignId, params]);
    },

    addTeam() {
      this.$refs.teamform.openModal();
    },

    editTeam(team) {
      this.$refs.teamform.openEditModal(team);
    },

    openModalImportTeams() {
      this.$refs.ImportTeamsModal.openModal();
    },

    openModalExportTeams() {
      const params = {
        parent_team_id: this.parent_team_id,
      };
      this.$refs.ExportTeamsModal.openModal(this.campaignId, { params });
    },

    loadNewPageTeams() {
      this.getTeams();
    },

    sendEmail({ team, importGroup } = {}) {
      this.$refs.emailMessage.open({ team, importGroup });
    },

    sendSMS({ team, importGroup } = {}) {
      this.$refs.smsMessage.open({ team, importGroup });
    },

    publishSelectedBulk({ publish = true }) {
      const params = {
        okText: this.$t("dashboard.teams_publish"),
        message: this.$t(
          "donors.teams_approved_confirm_msg_bulk",
          "Please confirm publishing of {counter} teams",
          { counter: this.bulkEventPageTeams.length }
        ),
        ids: this.bulkEventPageTeams,
        uncheck: this.uncheckBulkEventPageTeams,
        newPage: this.getTeams,
      };

      const { okText, ids, uncheck, newPage, message } = params;

      const options = {
        okText,
        cancelText: this.$t("donors.confirm_cancel"),
      };

      this.$dialog.confirm(message, options).then(() => {
        this.publishEventPageTeams(ids, publish).then(() => {
          uncheck(null);
          newPage({ force: true });
        });
      });
    },

    publishEventPageTeams(ids, publish) {
      const editTeam = (team) => {
        const payload = {
          data: {
            attributes: { ...team.attributes, event_page: publish },
          },
        };

        return axios
          .put(
            `${urls.editTeams
              .replace(":orgId", this.orgId)
              .replace(":campaignId", team.attributes.campaign_id)}/${team.id}`,
            payload
          )
          .then(() => {
            this.$_notificationsMixin_makeToast("Success", this.$t("edit_campaign.success_edit"));
          });
      };

      return Promise.all(ids.map(editTeam));
    },
  },

  created() {
    this.getTeams();
  },
};
</script>

<style lang="scss" scoped>
#import {
  @media only screen and (max-width: 1169px) {
    display: none;
  }
  ::v-deep .btn.disabled {
    opacity: initial;
  }
}
::v-deep .multiselect__tags {
  height: 48px;
  width: 100%;
  padding-left: 45px;
  border: 1px solid #88bacc;
  border-radius: 24px;
  padding: 0;
  padding-left: 30px;
}
::v-deep .multiselect__single,
::v-deep .multiselect__placeholder {
  margin: 0;
  line-height: 48px;
  background: #0000;
}
::v-deep .multiselect__select {
  height: 48px;
}
::v-deep .multiselect__input,
::v-deep .multiselect__single,
::v-deep .multiselect__placeholder {
  height: 48px;
  margin: 0;
  line-height: 48px;
  background: transparent;
  color: initial;
  padding: 0;
  font-family: inherit;
  font-size: 16px;
}
.donation-loading {
  display: flex;
  min-height: 100px;
  align-items: center;
  justify-content: center;
}
/*.btn-item {*/
/*margin-left: 10px;*/
/*}*/
.pagination {
  margin-top: 20px;
}

.clickable {
  cursor: pointer;
  i {
    padding-left: 3px;
  }
}

.pdf-button-donations {
  background-color: #fff;
  padding-bottom: 20px;
  a {
    display: block;
    width: 100%;
    padding: 10px 25px;
    background-color: #b4c5cd52;
    color: #127598;
    font-family: "VitoExtended-Bold";
  }
}

.dashboard-donation {
  &__type {
    flex-direction: column;
  }
  &__search {
    flex-direction: column;
  }
}

.th-item {
  &--5 {
    width: 5% !important;
    min-width: 5% !important;
  }
  &--10 {
    width: 10% !important;
    min-width: 10% !important;
  }
  &--30 {
    width: 30% !important;
    min-width: 30% !important;
  }
}
</style>
